



























































































































import { Component, Vue, Provide } from "vue-property-decorator";
import { pagnition } from "@/utils/commonConfig";
import { dateFormat, timeFormat } from "@/utils";
import { ticketClient, authorClient, client } from "@/api/index";
import { errorMsg, setCommon } from "@/utils/request";
import { ListUserGroupByTypeReq } from "@/pbjs/external/auth/auth_pb";
import {
  GetTicketItemListReq,
  GetCallingPlanConfigReq,
} from "@/pbjs/xcommon/ticket_pb";
import { SearchUserMiniReq } from "@/pbjs/external/user/user_pb";

const robotManage = () => import("./component/addEditDialog.vue");

@Component({
  name: "CombinationProperty",
  components: {
    robotManage,
  },
})
export default class CombinationProperty extends Vue {
  @Provide() private resultData: any = []; //列表
  @Provide() private result: any = {}; //编辑传过去的东西
  @Provide() private pagnition: any = pagnition;
  @Provide() private token: any = "";
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private isAddQuestion: boolean = false; // lee 是否展示添加弹窗
  @Provide() private roleDetailsOptions: any = []; //角色详情
  @Provide() private ticketCategory: any = []; //工单类型详情
  @Provide() private seattreeList: any = []; //坐席组
  @Provide() private talkresultList: any = []; //交谈结果
  @Provide() private dealmethodList: any = []; //处理方式
  @Provide() private staffList: any = []; //员工列表
  @Provide() private staffName: string = ""; //搜索员工名称

  private created() {
    this.token = localStorage.getItem("token");
    this.getRobotList();
    this.nxteleList();
    this.ListUserGroupByType();
    this.getCallingPlanConfig();
    this.getUserListMini();
  }
  private selectList() {
    this.pageIndex = 1;
    this.pageSize = 20;
    this.getRobotList();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getRobotList();
  }
  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getRobotList();
    }
  }
  // 隐藏添加弹窗
  private returnRiskReport() {
    this.isAddQuestion = false;
  }
  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getRobotList();
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getRobotList();
  }

  private hideDialog(): void {
    this.isAddQuestion = false;
  }
  // lee 关闭所有弹窗
  private hideAllDialog() {
    this.isAddQuestion = false;
    this.getRobotList();
  }
  private updateList() {
    this.pageIndex = 1;
    this.getRobotList();
  }
  // 列表
  private async getRobotList() {
    let _arg: any = {
      Page: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      },
      planName: null, //计划名称
      strategy: null, //策略名称
      timeRange: null, //开始时间 - 结束时间
      callingType: 1, //外呼类型 预测式外呼
    };
    const { getListCallingPlanReq, getListCallingPlanRequest }: any =
      await import("@/request/robotManage");
    let res = await getListCallingPlanRequest.handleHttp(
      getListCallingPlanReq(_arg),
      this
    );
    console.log("res-list", res);
    if (res && res.right) {
      this.pagerCount = res.pageout.total;
      this.resultData =
        res.listList && res.listList.length > 0 ? res.listList : [];
      this.resultData.forEach((item: any) => {
        item.starttime = dateFormat(item.starttime);
        item.endtime = dateFormat(item.endtime);
        item.utime = timeFormat(item.utime);

        let usergroupidList: any = [];
        let usergroupnameList: any = [];
        if (item.usergroupidsList.length > 0) {
          item.usergroupidsList.map((el: any) => {
            usergroupidList.push(el.id);
            usergroupnameList.push(el.name);
          });
        }
        let useridList: any = [];
        let useridnameList: any = [];
        if (item.useridsList.length > 0) {
          item.useridsList.map((el: any) => {
            useridList.push(el.id);
            useridnameList.push(el.name);
          });
        }
        let statusName = "";
        switch (item.status) {
          case 1:
            statusName = this.$tc("authority.Enable");
            break;
          case 2:
            statusName = this.$tc("authority.Disable");
            break;
        }
        let sequenceName = item.hours ? item.hours : "";
        let callingtype = item.callingtype == 2 ? "渐进式外呼" : "预测式外呼"; //1预测是外呼 2渐进式外呼
        this.$set(item, "callingtype", callingtype);
        this.$set(item, "sequenceName", sequenceName);
        this.$set(item, "statusName", statusName);
        this.$set(item, "usergroupidList", usergroupidList.toString());
        this.$set(item, "usergroupnameList", usergroupnameList.toString());
        this.$set(item, "useridList", useridList.toString());
        this.$set(item, "useridnameList", useridnameList.toString());
      });
    }
  }
  // 获取工单类型列表
  private nxteleList() {
    let request: any = new GetTicketItemListReq();
    request.setCommonin(setCommon());
    request.setIsstage();
    ticketClient.getTicketItemList(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        console.log("data-获取工单类型 list", data);
        if (!data.commonout || data.commonout.code == 0) {
          let _result =
            typeof data.listList == "object"
              ? data.listList
              : JSON.parse(data.listList);
          if (_result) {
            let period: any = [];
            if (data.listList) {
              data.listList.forEach((item: any) => {
                period.push({
                  name: item.casename,
                  id: item.id,
                });
              });
            }
            this.ticketCategory = period;
          }
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        if (err.code == 16) {
          this.$router.push("./login");
        }
      }
    });
  }

  // 获取员工列表
  private getUserListMini() {
    let request: any = new SearchUserMiniReq();
    request.setCommonin(setCommon());
    request.setName(this.staffName);
    client.searchUserMini(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        console.log("data-获取员工列表Mini list", data);
        if (!data.commonout || data.commonout.code == 0) {
          this.staffList = data?.userinfosList.map((item: any) => {
            return {
              id: item.id,
              name: item.name,
              email: item.email,
            };
          });
        } else if (data.code == 100100 || data.code == 100101) {
          this.$router.push("./login");
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  // 获取外呼计划配置列表
  private getCallingPlanConfig() {
    let request: any = new GetCallingPlanConfigReq();
    request.setCommonin(setCommon());
    ticketClient.getCallingPlanConfig(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          console.log("data-获取外呼计划配置列表 list", data);
          if (!data.commonout || data.commonout.code == 0) {
            this.seattreeList = data?.seattreeList; //坐席组
            this.talkresultList = data?.talkresult?.optionsList; //交谈结果
            this.dealmethodList = data?.dealmethodList; //处理方式
          } else if (data.code == 100100 || data.code == 100101) {
            this.$router.push("./login");
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        }
        if (err) {
          errorMsg(err);
        }
      }
    );
  }

  // 获取角色详情列表
  private ListUserGroupByType() {
    let request: any = new ListUserGroupByTypeReq();
    request.setCommonin(setCommon());
    request.setExectype(4);
    authorClient.listUserGroupByType(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        console.log("data-获取角色详情 list", data);
        if (!data.commonout || data.commonout.code == 0) {
          this.roleDetailsOptions = data.usergroupinfosList;
        } else if (data.code == 100100 || data.code == 100101) {
          this.$router.push("./login");
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  // 删除
  private deleteRobot(mes: any) {
    this.$confirm(
      "The dialing policy created by three parties on that day cannot be deleted. Once the local data is deleted, it cannot be recovered.",
      "",
      {
        confirmButtonText: this.$tc("ticket.Sure"),
        cancelButtonText: this.$tc("authority.cancel"),
        type: "warning",
      }
    )
      .then(() => {
        this.deleteRobotMes(mes);
      })
      .catch(() => {});
  }
  private async deleteRobotMes(data: any) {
    let _arg: any = {
      id: data.id,
      // 计划名称
      planName: data.planname,
      // 策略名
      strategy: data.strategy,
    };
    if (data.starttime && data.endtime) {
      // 开始时间 - 结束时间
      _arg.timeRange =
        dateFormat(data.starttime) + " - " + dateFormat(data.endtime);
    }
    const { deleteCallingPlanReq, deleteCallingPlanRequest }: any =
      await import("@/request/robotManage");
    let res = await deleteCallingPlanRequest.handleHttp(
      deleteCallingPlanReq(_arg),
      this
    );
    if (res && res.right) {
      this.$message({
        type: "success",
        message: "success",
      });
      this.getRobotList();
    }
  }
  private addLoadAttr() {
    this.result = {
      id: "",
      // 计划名称
      planName: "",
      // 策略名
      strategy: "",
      // 开始时间 - 结束时间
      time: [],
      // 时间段
      sequence: "",
      company: "",
      distinguish: "", //区分方式
      details: "", //详情
      status: "",
      resultStrategies: "",
    };
    this.isAddQuestion = true;
  }
  private editLoadAttr(row: any) {
    this.result = {
      id: row.id,
      // 计划名称
      planName: row.planname,
      // 策略名
      strategy: row.strategy,
      // 坐席组
      seatGroup: row.groupname,
      //坐席
      seatItem: row.agentnameList.join(","),
      //名单模板
      templateName: row.templatename,
      callingType: row.callingtype === "渐进式外呼" ? 2 : 1,
      // 开始时间 - 结束时间
      time: [dateFormat(row.starttime), dateFormat(row.endtime)],
      sequence: row.sequenceName,
      company: row.company,
      status: row.status,
      details:
        row.useridsList.length > 0
          ? Number(row.useridList)
          : Number(row.usergroupidList), //详情
      distinguish: row.useridList?.length > 0 ? "1" : "2",
      maxLostRate: row.maxlostrate,
      repeatTimes: row.repeattimes,
      voicemailRedial: row.voicemailredial,
      resultStrategies: row.resultstrategies,
    };
    this.isAddQuestion = true;
  }
}
